import React, { FC } from 'react';

import { VariantProps } from './variants';
import ReferencePickerBlockGroup from '../blocks/ReferencePickerBlockGroup';
import getPluginKey from '../helpers/getPluginKey';

export const ListVariant: FC<VariantProps> = ({
  groupData,
  allowRemoveLinkedEntity,
  setDataToConfirmRemoving,
  updateEntitiesInCache,
  onReferenceClickAnalytics,
  sourceEntityId,
  sourceEntityDomain,
  sourceEntityType,
}) => (
  <div>
    {groupData.map(({ plugin, entityCache, relationships }) => {
      return (
        <ReferencePickerBlockGroup
          key={getPluginKey(plugin)}
          plugin={plugin}
          relationships={relationships}
          entitiesCache={entityCache}
          allowRemoveLinkedEntity={allowRemoveLinkedEntity}
          setDataToConfirmRemoving={setDataToConfirmRemoving}
          updateEntitiesInCache={updateEntitiesInCache}
          onReferenceClickAnalytics={onReferenceClickAnalytics}
          sourceEntityId={sourceEntityId}
          sourceEntityDomain={sourceEntityDomain}
          sourceEntityType={sourceEntityType}
        />
      );
    })}
  </div>
);
